import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VCard,{attrs:{"data-testid":_vm.TEST_ID,"outlined":""}},[(_vm.$slots.title)?_c(VCardTitle,[_c('div',{staticClass:"font-weight-regular flex-grow-1"},[_vm._t("title")],2),_vm._t("badge")],2):_vm._e(),(_vm.$slots.subtitle)?_c(VCardSubtitle,{staticClass:"black--text"},[_vm._t("subtitle")],2):_vm._e(),(_vm.$slots.content)?_c(VCardText,{staticClass:"black--text"},[_vm._t("content")],2):_vm._e(),(_vm.$slots.actions)?_c(VCardActions,[_vm._t("actions")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }